import { DateHelper } from '@modules/core/helpers/date.helper';

export interface FormalitySpecificDatesJson {
  due_date?: string;
}

export class FormalitySpecificDates {
  constructor(public dueDate?: string) {}

  static fromJson(json: Partial<FormalitySpecificDatesJson>): FormalitySpecificDates {
    return new FormalitySpecificDates(json.due_date);
  }

  static toJson(formality: FormalitySpecificDates): FormalitySpecificDatesJson {
    return {
      due_date: formality.dueDate ? DateHelper.format(formality.dueDate, 'YYYY-MM-DD') : null
    };
  }
}
